import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import ElfsightWidget from '../components/about/ElfsightWidget';
import SEOHead from '../components/SEOHead';
import LeadersHero from '../components/leaders/LeadersHero';
import LeadersInvitation from '../components/leaders/LeadersInvitation';
import LeadersContainer from '../components/leaders/LeadersContainer';
import InnerTerritory from '../components/leaders/InnerTerritory';
import LeadersThreshold from '../components/leaders/LeadersThreshold';

const Services = () => {
  const servicesJsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Executive Coaching",
      "name": "1:1 Executive Coaching with ParadoxEdge",
      "provider": {
        "@type": "Organization",
        "name": "ParadoxEdge",
        "url": "https://www.paradoxedge.com"
      },
      "description":
        "A private 1:1 practice for senior leaders whose next level of impact asks for a different level of being.",
      "url": "https://www.paradoxedge.com/services",
      "areaServed": "Worldwide",
      "audience": { "@type": "BusinessAudience", "audienceType": "Senior executives and C-suite leaders" }
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.paradoxedge.com/" },
        { "@type": "ListItem", "position": 2, "name": "For Leaders", "item": "https://www.paradoxedge.com/services" }
      ]
    }
  ];

  return (
    <>
      <SEOHead
        title="For Leaders — Private 1:1 Executive Coaching | ParadoxEdge"
        description="A private 1:1 practice for senior leaders whose next level of impact asks for a different level of being."
        canonicalUrl="/services"
        keywords="executive coaching, 1:1 leadership coaching, private coaching, senior leadership development, inner work, presence-based coaching, vertical development"
        jsonLd={servicesJsonLd}
      />
      <div className="min-h-screen bg-background">
        <Navigation />
        <ElfsightWidget />

        <main>
          <LeadersHero />
          <LeadersInvitation />
          <LeadersContainer />
          <InnerTerritory />
          <LeadersThreshold />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Services;
